import React from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { isTouchScreen } from '@autobest-ui/utils';
var prefixCls = 'ab-mask';
function Mask(_a, ref) {
  var className = _a.className,
    _b = _a.timeout,
    timeout = _b === void 0 ? 300 : _b,
    _c = _a.onClose,
    onClose = _c === void 0 ? function () {} : _c,
    visible = _a.visible;
  // mousedown和touchstart会一起触发，这里判断后，只执行一次
  var onChangeVisible = React.useCallback(function (event) {
    var touch = isTouchScreen();
    if (event.type === 'touchstart' && touch || event.type === 'mousedown' && !touch) {
      onClose(event);
    }
  }, [onClose]);
  return /*#__PURE__*/React.createElement(CSSTransition, {
    "in": visible,
    timeout: timeout,
    classNames: "".concat(prefixCls, "-fade"),
    appear: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(prefixCls, className),
    onMouseDown: onChangeVisible,
    onTouchStart: onChangeVisible,
    ref: ref
  }));
}
export default /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(Mask));